export interface UAInfo {
  browser: string;
  os: string;
  device: "desktop" | "mobile" | "tablet" | "other";
}

/** Small UA parser for display only; the API may already supply browser/os/device. */
export function parseUA(ua: string): UAInfo {
  const s = ua || "";
  let browser = "Unknown";
  if (/Edg\//.test(s)) browser = "Edge";
  else if (/OPR\//.test(s)) browser = "Opera";
  else if (/Chrome\//.test(s) && !/Chromium/.test(s)) browser = "Chrome";
  else if (/Firefox\//.test(s)) browser = "Firefox";
  else if (/Safari\//.test(s) && /Version\//.test(s)) browser = "Safari";
  else if (/Backstory/.test(s)) browser = "Fixture";

  let os = "Unknown";
  if (/Windows/.test(s)) os = "Windows";
  else if (/iPhone|iPad|iPod/.test(s)) os = "iOS";
  else if (/Mac OS X/.test(s)) os = "macOS";
  else if (/Android/.test(s)) os = "Android";
  else if (/CrOS/.test(s)) os = "ChromeOS";
  else if (/Linux/.test(s)) os = "Linux";

  let device: UAInfo["device"] = "desktop";
  if (/iPad|Tablet/.test(s) || (/Android/.test(s) && !/Mobile/.test(s))) device = "tablet";
  else if (/Mobi|iPhone|Android/.test(s)) device = "mobile";
  else if (!s) device = "other";
  return { browser, os, device };
}
